(function(){
  var root=document.querySelector('[data-rtm-archive-v04]');
  if(!root)return;

  var grid=root.querySelector('[data-grid]');
  var cards=Array.prototype.slice.call(root.querySelectorAll('.rtm-story'));
  var tools=root.querySelector('[data-tools]');
  var clear=root.querySelector('[data-clear]');
  var freeToggle=root.querySelector('[data-free-toggle]');
  var search=root.querySelector('[data-search]');
  var status=root.querySelector('[data-status]');
  var announce=root.querySelector('[data-announce]');
  var viewBtns=Array.prototype.slice.call(root.querySelectorAll('[data-view-btn]'));
  var toggle=root.querySelector('[data-filter-toggle]');
  var heads=Array.prototype.slice.call(root.querySelectorAll('.rtm-head'));
  var tails=Array.prototype.slice.call(root.querySelectorAll('.rtm-tail'));
  var flags=Array.prototype.slice.call(root.querySelectorAll('.rtm-flag'));
  var feedMQ=window.matchMedia('(max-width: 1180px)');
  var LABELS={};
  try{LABELS=JSON.parse(root.getAttribute('data-labels')||'{}')}catch(e){LABELS={}}
  var BASE_STATUS=(status&&status.getAttribute('data-status'))||'Newest first in each pillar';

  function fold(v){return (v||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();}
  function norm(v){
    return(v||'').toLowerCase().trim().replace(/\s+/g,'-');
  }
  function titleCase(v){
    return(v||'').replace(/-/g,' ').replace(/\b\w/g,function(c){return c.toUpperCase()});
  }
  function numericPart(v){
    var m=(v||'').match(/\d+/);
    return m?parseInt(m[0],10):9999;
  }
  function labelFor(card,kind,value){
    var dataKey=kind+'Label';
    var label=card.dataset[dataKey]||'';
    if(label)return label;
    if(kind==='volume'){
      var n=numericPart(value);
      return n===9999?titleCase(value):'Volume '+n;
    }
    if(kind==='era')return (value||'').replace(/-/g,' ');
    var special={
      'bmw':'BMW','vw':'VW','mercedes-benz':'Mercedes-Benz','land-rover':'Land Rover',
      'rolls-royce':'Rolls-Royce','alfa-romeo':'Alfa Romeo','aston-martin':'Aston Martin'
    };
    return special[value]||titleCase(value);
  }
  function populateFilter(kind){
    if(!tools)return;
    var select=tools.querySelector('[data-filter="'+kind+'"]');
    if(!select)return;
    var seen={};
    cards.forEach(function(card){
      var value=norm(card.dataset[kind]);
      if(value&&!seen[value])seen[value]=labelFor(card,kind,value);
    });
    var values=Object.keys(seen);
    if(kind==='brand')values.sort(function(a,b){return seen[a].localeCompare(seen[b]);});
    else values.sort(function(a,b){return numericPart(a)-numericPart(b)||seen[a].localeCompare(seen[b]);});
    while(select.options.length>1)select.remove(1);
    values.forEach(function(value){
      var o=document.createElement('option');
      o.value=value;o.textContent=seen[value];select.appendChild(o);
    });
  }

  populateFilter('volume');
  populateFilter('brand');
  populateFilter('era');

  var selects=Array.prototype.slice.call(root.querySelectorAll('[data-filter]'));
  var state={brand:'',era:'',volume:'',q:'',access:'',view:'all'};

  function hasFilter(){return!!(state.brand||state.era||state.volume||state.q||state.access);}
  function chosenLabel(kind){
    var el=selects.filter(function(s){return s.dataset.filter===kind;})[0];
    if(!el)return'';
    var opt=el.options[el.selectedIndex];
    return opt&&opt.value?opt.textContent.trim():'';
  }
  function pillarName(key){
    var h=heads.filter(function(x){return x.dataset.pillar===key;})[0];
    var t=h&&h.querySelector('h2');
    return t?t.textContent.trim():key;
  }
  function matches(card){
    var title=fold(card.dataset.title);
    var tax=fold(card.dataset.taxonomy);
    if(state.brand&&norm(card.dataset.brand)!==state.brand)return false;
    if(state.era&&norm(card.dataset.era)!==state.era)return false;
    if(state.volume&&norm(card.dataset.volume)!==state.volume)return false;
    if(state.access==='free'&&card.dataset.accessTier!=='free')return false;
    if(state.q){
      var q=fold(state.q);
      if(title.indexOf(q)===-1&&tax.indexOf(q)===-1)return false;
    }
    return true;
  }
  function syncUrl(){
    if(root.dataset.editorialPreview==='true')return;
    var p=new URLSearchParams(location.search);
    ['brand','era','volume','q','access','pillar'].forEach(function(k){p.delete(k);});
    ['brand','era','volume','q','access'].forEach(function(k){if(state[k])p.set(k,state[k]);});
    if(state.view!=='all')p.set('pillar',state.view);
    var qs=p.toString();
    history.replaceState(null,'',location.pathname+(qs?'?'+qs:''));
  }
  function render(pushUrl){
    var feed=feedMQ.matches;
    var filtering=hasFilter();
    var pillarView=state.view!=='all';
    var any=false;

    cards.forEach(function(card){
      var show=matches(card)&&(!pillarView||card.dataset.pillar===state.view);
      card.hidden=!show;
      if(show)any=true;
    });

    if(grid)grid.setAttribute('data-mode',(filtering||pillarView)?'results':'archive');
    heads.forEach(function(h){h.classList.toggle('is-on',pillarView&&h.dataset.pillar===state.view);});
    tails.forEach(function(t){t.classList.toggle('is-on',pillarView&&t.dataset.pillar===state.view);});
    flags.forEach(function(f){f.classList.toggle('is-on',feed&&!filtering&&!pillarView);});
    root.classList.toggle('is-empty',!any);

    var chips=[];
    if(state.q)chips.push('“'+state.q+'”');
    if(chosenLabel('volume'))chips.push(chosenLabel('volume'));
    if(chosenLabel('brand'))chips.push(chosenLabel('brand'));
    if(chosenLabel('era'))chips.push(chosenLabel('era'));
    if(state.access==='free')chips.push(freeToggle.textContent.trim());
    if(status)status.textContent=filtering?'Showing '+chips.join(' · '):(pillarView?'Showing '+pillarName(state.view):BASE_STATUS);
    if(announce){
      if(!any)announce.textContent='No stories match these filters.';
      else if(filtering)announce.textContent='Archive filtered by '+chips.join(', ')+'.';
      else if(pillarView)announce.textContent='Showing '+pillarName(state.view)+', newest first.';
      else announce.textContent='Showing the full archive, newest first in each pillar.';
    }

    selects.forEach(function(s){
      s.value=state[s.dataset.filter]||'';
      s.setAttribute('data-on',s.value?'true':'false');
    });
    if(freeToggle)freeToggle.setAttribute('aria-pressed',String(state.access==='free'));
    if(search&&search.value!==state.q)search.value=state.q;
    viewBtns.forEach(function(b){b.setAttribute('aria-pressed',String(b.dataset.viewBtn===state.view));});
    if(pushUrl)syncUrl();
  }

  selects.forEach(function(s){
    s.addEventListener('change',function(){state[s.dataset.filter]=s.value;render(true);});
  });
  if(freeToggle)freeToggle.addEventListener('click',function(){state.access=state.access==='free'?'':'free';render(true);});
  if(search)search.addEventListener('input',function(){state.q=search.value.trim();render(true);});
  if(clear)clear.addEventListener('click',function(){
    state.brand=state.era=state.volume=state.q=state.access='';
    state.view='all';
    render(true);
    if(search)search.focus();
  });
  viewBtns.forEach(function(b){
    b.addEventListener('click',function(){state.view=b.dataset.viewBtn;render(true);});
  });
  if(toggle&&tools)toggle.addEventListener('click',function(){
    var open=tools.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded',String(open));
  });
  if(feedMQ.addEventListener){
    feedMQ.addEventListener('change',function(){
      if(tools)tools.classList.remove('is-open');
      render(false);
    });
  }

  if(root.dataset.editorialPreview==='true'){
    root.querySelectorAll('[data-preview-link]').forEach(function(a){
      a.addEventListener('click',function(e){e.preventDefault();});
    });
  }else{
    var params=new URLSearchParams(location.search);
    ['brand','era','volume'].forEach(function(k){if(params.get(k))state[k]=norm(params.get(k));});
    if(params.get('q'))state.q=params.get('q');
    if(params.get('access')==='free')state.access='free';
    if(params.get('pillar'))state.view=norm(params.get('pillar'));
  }

  /* Presentation bridge only. The real paywall/entitlement decision must remain server-side/app-side. */
  var entitlements={};
  var isMember=root.dataset.viewer==='member';
  cards.forEach(function(card){
    if(!card.dataset.accessSeed)card.dataset.accessSeed=card.dataset.access||'locked';
  });
  function entitlementState(key){
    var ent=entitlements[key];
    if(typeof ent==='string')return ent;
    return ent&&ent.state?ent.state:'';
  }
  function paint(card){
    var tier=card.dataset.accessTier||'premium';
    var seed=card.dataset.accessSeed||'locked';
    var eState=entitlementState(card.dataset.story);
    var next;
    if(tier==='free')next='free';
    else if(eState==='owned'||eState==='member')next=eState;
    else if(isMember)next='member';
    else next=seed;
    card.dataset.access=next;
    var text=card.querySelector('[data-access-text]');
    if(text&&LABELS[next])text.textContent=LABELS[next];
  }
  function refresh(){cards.forEach(paint);}
  window.RTMAccess={
    version:'v04',
    set:function(map){
      Object.keys(map||{}).forEach(function(k){entitlements[k]=map[k];});
      refresh();
    },
    replace:function(map){entitlements=map||{};refresh();},
    setMember:function(on){isMember=!!on;root.dataset.viewer=on?'member':'guest';refresh();},
    refresh:refresh,
    storyKeys:function(){return cards.map(function(c){return c.dataset.story;}).filter(Boolean);},
    states:['free','locked','owned','member']
  };
  refresh();
  render(false);
  try{window.dispatchEvent(new CustomEvent('rtm:access-ready',{detail:{version:'v04'}}));}catch(e){}
})();

